import React from 'react';

//material mui components
import { Typography } from '@mui/material';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';

//icons material
import HowToRegOutlinedIcon from '@mui/icons-material/HowToRegOutlined';
import CircleIcon from '@mui/icons-material/Circle';

//hooks
import { useGlobalState } from '../../../../Utilidades/useGlobalState';

//styles
import { StyleHomeHeader } from '../../../Tool/Style'

export const StepperMobile = ({ EstadoRegistro }) => {

  const { etiquetas } = useGlobalState();

  return (
   <div style={{ display: 'flex', justifyContent:'center' }}>
   <div style={StyleHomeHeader.DivCircleContainer}>
       <div style={StyleHomeHeader.DivCircleIconContainer}>
           <CircleIcon style={StyleHomeHeader.IconCircle} />
           <Typography component="span" style={StyleHomeHeader.DivCircleIconText}>{1}</Typography>
       </div>
       <Typography style={StyleHomeHeader.EstadoText}>{etiquetas.Home.Et_lblRegistro}</Typography>
   </div>
   <LinearProgress 
       variant="determinate"
       value={EstadoRegistro === true ? 50 : 100}
       sx={{
           marginTop: '7%',
           width: 250,
           height: 10,
           borderRadius: 5,
           [`&.${linearProgressClasses.colorPrimary}`]: {
               backgroundColor: '#EDF0F4',
           },
           [`& .${linearProgressClasses.bar}`]: {
               borderRadius: 5,
               backgroundColor: '#082375',
           },
       }}
   />
   <div style={StyleHomeHeader.DivCircleContainer}>
       <div style={StyleHomeHeader.DivCircleIconContainer}>
           <CircleIcon style={{ ...StyleHomeHeader.IconCircle, ...{ color: EstadoRegistro === true ? '#EDF0F4' : '#082273' } }} />
           <Typography component="span" style={{ ...StyleHomeHeader.DivCircleIconText, ...{ color: EstadoRegistro === true ? '#666666' : '#FFFFFF'} }}>{2}</Typography>
       </div>
       <Typography style={EstadoRegistro === true ? { ...StyleHomeHeader.EstadoText, ...{ color: '#3F425D', fontWeight: 400 } } : StyleHomeHeader.EstadoText}>{etiquetas.Home.Et_lblAdmision}</Typography>
   </div>
</div>
  )
}
